import React from "react";
import NotFound from "src/assets/images/website-images/404-image.jpg";

const Banner = ({
  image,
  className,
  loadingClassName,
  style,
  onClick,
  blackOverlay,
  isLoading,
  id = ""
}: {
  image: {
    image: string;
    name: string;
    _id: string;
  };
  className?: string;
  loadingClassName?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  blackOverlay?: boolean;
  isLoading?: boolean;
  id?: string;
}) => {
  return (
    <div className="relative">
      {!isLoading && (
        <img
          src={image?.image || NotFound}
          onClick={onClick}
          id={id}
          alt="banner"
          className={`w-full h-[350px] rounded-xl object-cover ${className}`}
          loading="lazy"
          onError={(e) => (e.currentTarget.src = NotFound)}
          style={{ ...style }}
        />
      )}
      {isLoading && (
        <div
          className={`rounded-xl bg-image-loader w-full h-[350px] ${loadingClassName}`}
        ></div>
      )}
      {blackOverlay && (
        <div className="absolute inset-0 bg-black/30 rounded-xl"></div>
      )}
    </div>
  );
};

export default Banner;
